import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) { }

  getStates() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/getStates', httpOptions);
  }
  
  getCityByState(stateId: any) {
    const param = new HttpParams().set('id', stateId);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/getCityByState', httpOptions);
  }

  registerHospital(data:any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/register-provider-data',data, httpOptions);
  }

  getProviderContactType(){
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/getAllProviderContactType', httpOptions);
  }

  getCityAndStateByPincode(pincode:any){
    const params = new HttpParams().set('pincode', pincode);
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      params: params
    };
    return this.http.get(environment.apiBaseUrl + '/getCityAndStateByPincode', options);
  }

  getCaptcha() {
    return this.http.get(environment.apiBaseUrl  + '/generate-captcha');
  }

  getAllCertificates() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/getAllCertificateName', httpOptions);
  }
}
